var React = require('react');

function PatternTriangle4Inline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Pattern/Circual/Light/Green Copy 2"),React.createElement("path",{"d":"M0 35h40.47L20.235 0M40.47 35h40.468L60.704 0m20.234 35h40.468L101.174 0m20.232 35h40.47L141.642 0","key":1})]);
}

PatternTriangle4Inline.defaultProps = {"width":"163","height":"35","viewBox":"0 0 163 35"};

module.exports = PatternTriangle4Inline;

PatternTriangle4Inline.default = PatternTriangle4Inline;
